import React from 'react'
import './index.scss'
import * as components from '../../second'
import { isAndroid } from '../../utils/limit'
import { isLongScreen } from '../../utils/utils'
interface tabItem {
  tabName?: string
  icon?: string
  activeIcon?: string
  tabId?: string
  tabUrl?: string
  text?:string
}

interface config {
  tabs?: tabItem[]
  color?: string
  activeColor?: string
  type?:'text' | 'image'
}
interface IConferenceProps {
  config: config
  clickTo: (
    type?: string,
    path1?: string,
    path2?: string,
    componentId?: string
  ) => void
  id: string
  pid: string
  withData: any
  getCampaignContent: any
}
interface IConferenceState {
  activeIndex: number
  content: any
}
const TreeNode = (props: any) => {
  const { render, childrens, config, clickTo, ...otherProps } = props
  return React.createElement(
    components[render] || 'div',
    {
      render,
      config,
      clickTo,
      ...otherProps,
    },
    childrens && childrens.length > 0 ? (
      childrens.map((c) => TreeNode({ ...c, clickTo }))
    ) : (
      <div></div>
    )
  )
}

class Conference extends React.Component<IConferenceProps, IConferenceState> {
  state = {
    activeIndex: 0,
    content: null,
  }
  componentDidMount() {
    this.getPageContent()
  }
  shouldComponentUpdate(nextProps) {
    const { activeIndex } = this.state
    let url = nextProps?.config?.tabs?.[activeIndex]?.tabUrl
    // if (nextProps?.config?.tabs === this.props?.config?.tabs) {
    //   return false
    // }
    if (url && url !== this.props?.config?.tabs[activeIndex]?.tabUrl) {
      this.getPageContent(url)
    }
    return true
  }
  checkUrl = (str) => {
    let RegUrl = new RegExp(
      '^[A-Za-z]+://[A-Za-z0-9-_]+\\.[A-Za-z0-9-_%&?/.=]+$'
    )
    if (!RegUrl.test(str)) {
      return false
    }
    return true
  }
  getPageContent = (url?: string) => {
    const { activeIndex } = this.state
    const { config, getCampaignContent } = this.props
    if (!config.tabs) return
    let activeItem = config.tabs[activeIndex]
    if (!url) url = activeItem.tabUrl
    if (!this.checkUrl(url)) return
    getCampaignContent(url).then((res) => {
      this.setState({
        content: res.data,
      })
    })
  }
  switchTab = (tabIndex) => {
    let node = document.querySelector('.pageContent')
    this.setState(
      {
        activeIndex: tabIndex,
      },
      () => {
        this.getPageContent()
        if (node) node.scrollTop = 0
      }
    )
  }
  WrapperContent = this.props.withData(TreeNode, components)
  render() {
    const WrapperContent = this.WrapperContent
    const { config, clickTo } = this.props
    const { activeIndex, content } = this.state
    const bgColor = content?.root?.config?.bgColor
    return (
      <div className="conferenceContent">
        <div className="secondContent" style={{ backgroundColor: bgColor }}>
          {config.tabs && (
            <WrapperContent tree={content} clickTo={clickTo}></WrapperContent>
          )}
        </div>
        <div
          className={`bottomBarContent ${
            isAndroid() ? 'barFixd' : 'barSticky'
          } ${isLongScreen() ? 'longBottom' : ''}`}
        >
          {config?.tabs?.map((item, index) => {
            return (
              <div
                className="bottombarItem"
                key={`tab${index}`}
                onClick={() => this.switchTab(index)}
              >
                {config.type === 'text'
                  ? item?.text && (
                      <div
                        className={[
                          'iconContent',
                          'text-content',
                          activeIndex === index ? 'active-item' : '',
                          config?.tabs?.length > 4 ? 'font-size-22' : '',
                          item.text?.length > 4 ? 'tab-5' : '',
                        ].join(' ')}
                      >
                        {item.text?.length > 4 ? (
                          <>
                            <p>{item.text?.slice(0, 2)}</p>
                            <p>{item.text?.slice(2)}</p>
                          </>
                        ) : (
                          <p>{item.text}</p>
                        )}
                      </div>
                    )
                  : item?.icon && (
                      <div className="iconContent">
                        <img
                          src={
                            activeIndex === index
                              ? item?.activeIcon
                              : item?.icon
                          }
                          alt=""
                        ></img>
                      </div>
                    )}
                {/* {item?.tabName && (
                  <span
                    className="bottomTabtext"
                    style={{
                      color: activeIndex === index ? activeColor : color,
                    }}
                  >
                    {item?.tabName}
                  </span>
                )} */}
              </div>
            )
          })}
        </div>
      </div>
    )
  }
}

export default Conference
